import baseHttpService from "core/http/singleton/base";

import {
  ActionLikeRes,
  getCommentsRes,
  getNewsRes,
  getNewsTabsRes,
  NewsItem,
  postCommentRes,
} from "./resTypes";

import {
  getCommentsURL,
  getNewsDetailURL,
  getNewsTabsUrl,
  getNewsUrl,
  likeNewsURL,
  postCommentURL,
} from "./urls";

import {
  ActionLikeParams,
  GetCommentsParams,
  GetNewsDetailParams,
  getNewsParams,
  PostCommentsParams,
} from "./paramsTypes";

export const getListCommentAPI = async (
  payload: GetCommentsParams
): Promise<getCommentsRes> => {
  const { screenCode, type, objectId, ...params } = payload;
  const res = await baseHttpService.get<getCommentsRes>(
    getCommentsURL({ screenCode, type, objectId }),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const postNewCommentAPI = async (
  payload: PostCommentsParams
): Promise<postCommentRes> => {
  const { screenCode, ...body } = payload;
  const res = await baseHttpService.post<postCommentRes>(
    postCommentURL({ screenCode }),
    body
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getNewsTabsApi = async (): Promise<getNewsTabsRes> => {
  const res = await baseHttpService.get<getNewsTabsRes>(
    getNewsTabsUrl({ screenCode: "IP_008" })
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getNewsApi = async (
  payload: getNewsParams
): Promise<getNewsRes> => {
  const { params } = payload;
  const res = await baseHttpService.get<getNewsRes>(
    getNewsUrl({ screenCode: "IP_008" }),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getNewsDetailApi = async (
  payload: GetNewsDetailParams
): Promise<NewsItem> => {
  const res = await baseHttpService.get<NewsItem>(getNewsDetailURL(payload));
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const likeNewsApi = async (
  payload: ActionLikeParams
): Promise<ActionLikeRes> => {
  const res = await baseHttpService.post<ActionLikeRes>(likeNewsURL(payload));
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
